import * as THREE from 'three'


export default class ViewerGUI{
  constructor(camera){
    this.camera = camera;
    document.getElementsByClassName("forward")[0].addEventListener('click', this.onButton.bind(this));
    document.getElementsByClassName("back")[0].addEventListener('click', this.onButton.bind(this));
    document.getElementsByClassName("left")[0].addEventListener('click', this.onButton.bind(this));
    document.getElementsByClassName("right")[0].addEventListener('click', this.onButton.bind(this));
  }


  onButton(e){
    const className = e.currentTarget.className;
    if(!this.camera)
      return;

    const camSpeed = 100.0;
    const camRotate = Math.PI/24;
    let dir = new THREE.Vector3(); 
    if(className.indexOf("forward") > 0){
      this.camera.getWorldDirection( dir );
      this.camera.position.addScaledVector( dir, camSpeed );
    }else if(className.indexOf("back") > 0){
      this.camera.getWorldDirection( dir );
      this.camera.position.addScaledVector( dir, -1*camSpeed );
    }else if(className.indexOf("left") > 0){
      this.camera.rotation.y -= camRotate;
    }else if(className.indexOf("right") > 0){
      this.camera.rotation.y += camRotate;
    }
  }
}
